import { useState, type FormEvent } from 'react';
import { useNavigate } from '@tanstack/react-router';
import type { LoginResponse } from '@thebb/shared';
import { post } from '../api';
import { useAuth } from '../auth';
import { ErrorBox } from '../components/ui';
import { LogoMark } from '../components/Logo';

export function LoginPage() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [needTotp, setNeedTotp] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await post<LoginResponse>('/auth/login', { email, password, totp: totp || undefined });
      if (r.status === 'totp_required') {
        setNeedTotp(true);
        return;
      }
      await refresh();
      await navigate({ to: '/' });
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 via-canvas to-canvas p-4">
      <form onSubmit={submit} className="card w-full max-w-sm space-y-4">
        <div className="flex flex-col items-center gap-2 py-2">
          <LogoMark size={48} />
          <h1 className="text-xl font-bold tracking-tight">
            TheBB<span className="text-primary">System</span>
          </h1>
          <div className="text-xs font-medium uppercase tracking-wider text-muted">Borg & Bigum · back office</div>
        </div>
        <ErrorBox error={error} />
        <div>
          <label className="label">E-mail</label>
          <input className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </div>
        <div>
          <label className="label">Adgangskode</label>
          <input className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {needTotp && (
          <div>
            <label className="label">Kode fra din authenticator</label>
            <input className="input" inputMode="numeric" pattern="\d{6}" value={totp} onChange={(e) => setTotp(e.target.value)} required autoFocus />
          </div>
        )}
        <button className="btn btn-primary w-full justify-center" disabled={busy}>
          {busy ? 'Logger ind…' : 'Log ind'}
        </button>
      </form>
    </div>
  );
}
